// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"91":"6758a74d","98":"8005c605","118":"3bd34107","175":"8a2d98d2","264":"d0f7b58e","364":"8385d3e0","388":"79367c0d","412":"8b32a154","492":"756583ca","558":"73c73490","639":"f99f3c44","702":"85965026","714":"e8f71f66","792":"138b07ba"}[chunkId] + ".js";
};